<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title>
        <v-btn text small :to="{ name: 'RegistrationList' }">
          <v-icon left> mdi-arrow-left </v-icon>
          Back
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          outlined
          class="mx-2"
          @click="downloadLink(receipt)"
        >
          <v-icon left> mdi-download </v-icon>
          Download
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col cols="8" offset="2">
            <v-card-text class="elevation-1 my-1">
              <pdf style="width: 100%" :src="receipt" />
            </v-card-text>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import FileMixin from "@brainspore/celadon-base/mixin/FileMixin";
import pdf from "vue-pdf";
export default {
  name: "RenewalReceipt",
  components: { pdf },
  mixins: [FileMixin],
  data: function () {
    return {};
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Renewal/getRenewalReceipt", to.params.code);
    });
  },
  computed: {
    receipt() {
      return this.$store.getters["Renewal/renewalGetters"]("receipt");
    },
  },
};
</script>

<style scoped></style>
